<template>
    <div id="contenedor-listado-proyecto-documentos-tipos-desktop">

        <v-card
          flat>
          <v-card-title class="secondary--text">
            Tipos de Documentos
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
          </v-card-title>
          <tool-bar
            v-on:nuevoProyectoDocumentoTipo="agregarNuevoProyectoDocumentoTipo">
          </tool-bar>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="getProyectosDocumentosTipos"
              disable-pagination
              hide-default-footer>
              <template v-slot:[`item.acciones`]="{ item }">
                <opciones :proyectoDocumentoTipo="item"></opciones>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      <!-- Ventana Agregar Proyecto Documento Tipo -->
    <v-dialog
      v-if="mostrarVentanaAgregarProyectoDocumentoTipo"
      v-model="mostrarVentanaAgregarProyectoDocumentoTipo"
      persistent
      width="600">
      <agregar-proyecto-documento-tipo
      v-on:cerrar="cerrarVentana">
      </agregar-proyecto-documento-tipo>
    </v-dialog>
    <!-- Ventana Editar Proyecto Documento Tipo -->
    <v-dialog
      v-if="esteProyectoDocumentoTipo"
      v-model="mostrarVentanaEditarProyectoDocumentoTipo"
      scrollable
      persistent
      width="600">
      <editar-proyecto-documento-tipo
      :proyectoDocumentoTipoEditar="esteProyectoDocumentoTipo"
      v-on:cerrar="cerrarVentana">
      </editar-proyecto-documento-tipo>
    </v-dialog>
    <!-- Ventana Eliminar Proyecto Documento Tipo -->
    <v-dialog
      v-if="esteProyectoDocumentoTipo"
      v-model="mostrarVentanaEiminarProyectoDocumentoTipo"
      scrollable
      persistent
      width="400">
      <eliminar-proyecto-documento-tipo
      :proyectoDocumentoTipoEliminar="esteProyectoDocumentoTipo"
      v-on:cerrar="cerrarVentana">
      </eliminar-proyecto-documento-tipo>
    </v-dialog>
    </div>
  </template>

<script>
import PROYECTOS_DOCUMENTOS_TIPOS from '@/graphql/querys/administracion/control-proyectos/documentos-tipos/proyectosDocumentosTipos.gql';
import AgregarProyectoDocumentoTipo from '../Agregar.vue';
import EditarProyectoDocumentoTipo from '../Editar.vue';
import EliminarProyectoDocumentoTipo from '../Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Opciones from './Opciones.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoProyectoDocumentosTiposDesktop',
  components: {
    AgregarProyectoDocumentoTipo,
    EditarProyectoDocumentoTipo,
    EliminarProyectoDocumentoTipo,
    ToolBar,
    Opciones,
  },
  apollo: {
    proyectosDocumentosTipos: {
      query: PROYECTOS_DOCUMENTOS_TIPOS,
    },
  },
  data() {
    return {
      mostrarVentanaAgregarProyectoDocumentoTipo: false,
      mostrarVentanaEditarProyectoDocumentoTipo: false,
      mostrarVentanaEiminarProyectoDocumentoTipo: false,
      esteProyectoDocumentoTipo: null,
      headers: [
        { text: 'Nombre / Descripción', sortable: false, value: 'descripcion' },
        {
          text: '', align: 'end', sortable: false, value: 'acciones',
        },
      ],
    };
  },
  mounted() {
    eventBus.$on('editar-proyecto-documento-tipo', (proyectoDocumentoTipo) => {
      this.mostrarVentanaEditarProyectoDocumentoTipo = true;
      this.esteProyectoDocumentoTipo = proyectoDocumentoTipo;
    });
    eventBus.$on('eliminar-proyecto-documento-tipo', (proyectoDocumentoTipo) => {
      this.mostrarVentanaEiminarProyectoDocumentoTipo = true;
      this.esteProyectoDocumentoTipo = proyectoDocumentoTipo;
    });
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    cerrarVentana() {
      this.mostrarVentanaAgregarProyectoDocumentoTipo = false;
      this.mostrarVentanaEditarProyectoDocumentoTipo = false;
      this.mostrarVentanaEiminarProyectoDocumentoTipo = false;
      this.esteProyectoDocumentoTipo = null;
    },
    agregarNuevoProyectoDocumentoTipo() {
      this.mostrarVentanaAgregarProyectoDocumentoTipo = true;
    },
  },
  computed: {
    getProyectosDocumentosTipos() {
      if (!this.proyectosDocumentosTipos) return [];
      return this.proyectosDocumentosTipos;
    },
  },
};
</script>

  <style lang="scss">

  </style>
